import { TYPOGRAPHY_STYLES } from '../../CustomerDetailsFormSection/constants';

// COMPONENTS
import { Link } from 'components/Link';
import { Typography } from 'ui';
import { Box } from 'vendor/material';

// ASSETS
import { ArrowLeft } from 'mdi-material-ui';

export default function BackLink({
  onClick,
  text = 'Back',
}: {
  onClick: () => void;
  text?: string;
}) {
  return (
    <Box mb={2}>
      <Typography style={{ ...TYPOGRAPHY_STYLES, fontSize: 14 }}>
        <Link
          onClick={() => {
            onClick();
          }}
          data-id={'create_msft_referral_add_customer_back_link'}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <ArrowLeft fontSize="small" />
          {` ${text}`}
        </Link>
      </Typography>
    </Box>
  );
}
